import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledLoginField = styled(TextField)(({ theme }) => ({
  width: "100%",
  "& input": {
    fontWeight: "400",
    color: theme.palette.primary.main,
  },
  "& .MuiInputLabel-root": {
    fontWeight: "400",
  },
}));

export default StyledLoginField;
